module.exports = __webpack_public_path__ + "static/media/step4_14.07812004.png";